import {graphql} from 'gatsby'
import React from 'react'
import styled from 'styled-components'

import Button from '@/components/button'
import {Section} from '@/styles/grid'
import mq from '@/utils/media-query'

import type {GlassdoorWidgetSliceFragment} from '@/graphql-types'

type Props = {
    slice: GlassdoorWidgetSliceFragment
}

export const GlassdoorWidgetSlice = ({slice}: Props) => {
    const {cta_link, cta_text, widget_alt_text} = slice.primary

    return (
        <Section>
            <ContentWrapper>
                <a href="https://www.glassdoor.com/Overview/Working-at-Pleo-EI_IE1518165.11,15.htm">
                    <img
                        alt={widget_alt_text}
                        src="https://www.glassdoor.com/api/widget/horizontalStarRating.htm?e=1518165"
                    />
                </a>
                <StyledButton
                    forwardedAs="a"
                    $variant="outline"
                    href={cta_link.url}
                    data-testid="glassdoor-widget-cta"
                >
                    {cta_text}
                </StyledButton>
            </ContentWrapper>
        </Section>
    )
}

const ContentWrapper = styled.div`
    display: grid;
    justify-content: center;
    grid-gap: ${({theme}) => theme.spacings.s32};

    ${mq.min('sm')} {
        grid-gap: ${({theme}) => theme.spacings.s40};
    }
`

const StyledButton = styled(Button)`
    width: fit-content;
    justify-self: center;
`

export const glassdoorWidgetSliceFragment = graphql`
    fragment GlassdoorWidgetSlice on PrismicSlicePageDataBodyGlassdoorWidget {
        __typename
        primary {
            cta_link {
                ...PrismicLink
            }
            cta_text
            widget_alt_text
        }
    }
`
